import React from 'react'
import ProptType from 'prop-types'
import { simpleStrDate } from 'utils/format'
import {
  TopInfo,
  TopInfoItem,
} from './styles'

export default function Top({ payment }) {
  const paymentMethod = () => {
    if (payment.attributes.payment_methods?.length === 1) {
      const [firstPaymentMethod] = payment.attributes.payment_methods
      return firstPaymentMethod.method
    }

    return 'Outros'
  }
  return (
    <TopInfo>
      <TopInfoItem>
        <div>
          Cupom de Venda Nº
        </div>
        <div>
          { payment.attributes.code }
        </div>
      </TopInfoItem>
      <TopInfoItem>
        <div>
          Data da Venda
        </div>
        <div>
          { simpleStrDate(payment.attributes.date) }
        </div>
      </TopInfoItem>
      <TopInfoItem>
        <div>
          Atendente
        </div>
        <div>
          { payment.attributes.attendant?.name }
        </div>
      </TopInfoItem>
      <TopInfoItem>
        <div>
          Total de Itens
        </div>
        <div>
          { payment.attributes.total_items }
        </div>
      </TopInfoItem>
      <TopInfoItem>
        <div>
          Pagamento
        </div>
        <div>
          { paymentMethod() }
        </div>
      </TopInfoItem>
    </TopInfo>
  )
}

Top.propTypes = {
  payment: ProptType.objectOf(ProptType.any).isRequired,
}
